import React from "react";
import { Paper, CircularProgress, Typography } from "@mui/material";

const LoadingCard = ({
  message = "Loading, please wait...",
  size = 36,
  minHeight = 160,
  gradient = "linear-gradient(135deg, #f8f9fb, #eef2f7)",
}) => {
  return (
    <Paper
      elevation={3}
      sx={{
        p: 3,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight,
        background: gradient,
        width: "100%",
      }}
    >
      <CircularProgress size={size} thickness={4} />

      <Typography
        sx={{
          mt: 2,
          fontSize: "0.95rem",
          fontWeight: 600,
          textAlign: "center",
          letterSpacing: 0.3,
          background: "linear-gradient(90deg, #555, #888)",
          WebkitBackgroundClip: "text",
          WebkitTextFillColor: "transparent",
          lineHeight: 1.4,
        }}
      >
        {message}
      </Typography>
    </Paper>
  );
};

export default LoadingCard;
